import React, { useState } from "react";
import { Modal, Button, Input } from "antd";

const ScoreModal = ({ open, onClose, onSave }) => {
  const [score, setScore] = useState("");

  const handleSave = () => {
    if (score === "") return;
    onSave(score); // pass score to parent
    setScore(""); // reset
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={400}
      className="score-modal thanks-modal"
    >
      <div style={{ textAlign: "center" }}>
        <h2 style={{ marginBottom: 10, color: "white" }}>Enter Score</h2>

        <Input
          type="number"
          value={score}
          onChange={(e) => setScore(e.target.value)}
          placeholder="Enter score"
          className="enter-score-input"
        />

        <div
          style={{
            display: "flex",
            gap: 10,
            justifyContent: "flex-end",
          }}
        >
          <Button
            className="border-button main-border-button_newss"
            onClick={onClose}
          >
            Cancel
          </Button>

          <Button className="fill-button-smal" onClick={handleSave}>
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ScoreModal;
